const initialState = {
  loading: false,
  success: false,
  message: "",
};

export const changePasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_PASSWORD_REQUEST":
      return { ...state, loading: true, success: false, message: "" };

    case "CHANGE_PASSWORD_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        message: action.payload.message || "Password changed successfully.",
      };

    case "CHANGE_PASSWORD_FAILURE":
      return {
        ...state,
        loading: false,
        success: false,
        message: action.payload?.message || "Failed to change password.",
      };

    default:
      return state;
  }
};
